import {
	AccessTime,
	AccountTree,
	DataObject,
	Event,
	Fingerprint,
	FormatListBulleted,
	Numbers,
	Tag,
	TextFields,
	ToggleOn,
} from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';

import { PrimitiveType, SchemaPropertyModel } from '../../../api/api';

interface Props {
	prop: SchemaPropertyModel;
}

const getPropertyTypeLabel = (prop: SchemaPropertyModel) => {
	if (prop.isReferenceProperty || prop.isComplex) {
		return prop.referenceSchemaShortName || 'Schema';
	}

	if (prop.isEnum) {
		return 'Enum';
	}

	return prop.type;
};

const getPropertyTypeIcon = (prop: SchemaPropertyModel) => {
	if (prop.isReferenceProperty || prop.isComplex || prop.type === PrimitiveType.Ref) {
		return <AccountTree fontSize="small" />;
	}

	if (prop.isEnum || prop.type === PrimitiveType.Enum) {
		return <Tag fontSize="small" />;
	}

	switch (prop.type) {
		case PrimitiveType.Integer:
		case PrimitiveType.Decimal:
			return <Numbers fontSize="small" />;
		case PrimitiveType.Boolean:
			return <ToggleOn fontSize="small" />;
		case PrimitiveType.Guid:
			return <Fingerprint fontSize="small" />;
		case PrimitiveType.Date:
		case PrimitiveType.DateTime:
			return <Event fontSize="small" />;
		case PrimitiveType.Time:
		case PrimitiveType.TimeSpan:
			return <AccessTime fontSize="small" />;
		case PrimitiveType.Collection:
			return <FormatListBulleted fontSize="small" />;
		case PrimitiveType.Object:
			return <DataObject fontSize="small" />;
		case PrimitiveType.String:
		default:
			return <TextFields fontSize="small" />;
	}
};

export default function PropertyTypeIcon({ prop }: Props) {
	return (
		<Tooltip title={getPropertyTypeLabel(prop)}>
			<Box component="span" sx={{ display: 'inline-flex', color: 'text.secondary', flexShrink: 0 }}>
				{getPropertyTypeIcon(prop)}
			</Box>
		</Tooltip>
	);
}
